import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { buildSentryIOOptions } from '@asamco/application-link/shared';
import * as Sentry from '@sentry/angular-ivy';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

Sentry.init(buildSentryIOOptions());

bootstrapApplication(AppComponent, appConfig).catch(e => {
	console.error(e);
});
